import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { RulesApiAdapter } from '../adapters/RulesApiAdapter';
import { Filters } from '../models/Filters';
import { Service } from '../services/Service';

// useRules.ts
// Hook que gestiona la obtención, paginación y actualización de la lista de reglas de envío desde la API.

export const useRules = (filters: Filters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new RulesApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const {
    data,
    isLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['rules', filters],
    queryFn: ({ pageParam = 1 }) =>
      service.getPaginated({
        ...filters,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    staleTime: 5 * 60 * 1000,
  });

  const rules = data?.pages.flatMap((page) => page.rules) ?? [];

  // Obtener el total del API (siempre sera el mismo en todas las paginas)
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    rules,
    isLoading: isLoading || isPending,
    error,
    refetch,
    // Nuevas props para scroll infinito
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    // Stats útiles
    totalPages: data?.pages.length ?? 0,
    totalLocations: rules.length,
    total: totalFromApi, // Total real del API
  };
};
